import React from "react";
import { Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";


const OrganigramaOperacional = () => {
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="container text-center">
          <div className="row">
            <div className="col">
              <div className="TituloPrincipal">
                <br /> <h1>Organigrama Operacional</h1>
              </div>
              <center>
                <hr className="linea-horizontal"></hr>
              </center>
            </div>
            <div className="col">
              <div className="Text_Buttons_Radio_buttons">
                <p className="ParrafoPrincipal">
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container">
          <table class="styled-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Nombre Del Proceso</th>
                <th>Descripción</th>
                <th>Documentación</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>
                  <p>
                    <b>Estructura Operativa</b>
                  </p>
                </td>
                <td>
                  <p>
                    El organigrama de operaciones de 
                    Netjer Networks es fundamental para comprender la 
                    estructura y funcionamiento interno de la organización. 
                    Este diagrama jerárquico representa la distribución de 
                    responsabilidades y roles dentro de Netjer, permitiendo 
                    una visión clara de estructura de trabajo.
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/organigrama-operacional/estructura-operativa"
                  >
                    Organigrama
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Container>
    </>
  );
};

export default OrganigramaOperacional;

// https://app.diagrams.net/#G1HJo4V6_lXFNTb4mwHiA1kvTAdCy4tg1F
